import React, { useMemo } from 'react';
import { FormItem } from '@packages/utils';
import { Select } from 'components/Base/Select';
import { TGoalLevelFieldsProps } from './GoalLevelFields.types';

const GoalLevelFields: React.FC<TGoalLevelFieldsProps> = ({
  pillarsOfStrength,
  selectedPillarId,
  selectedSubPillarId,
  onGoalChange,
  disabled,
  goalDataCy,
  levelDataCy,
}) => {
  const pillars = pillarsOfStrength?.pillars ?? [];

  const selectedPillar = useMemo(
    () => pillars.find(p => p.id === selectedPillarId),
    [pillars, selectedPillarId],
  );

  const subPillarOptions = useMemo(
    () =>
      selectedPillar?.subPillars.map(sp => ({
        label: sp.description,
        value: sp.id,
      })) ?? [],
    [selectedPillar],
  );

  const selectedSubPillar = useMemo(
    () => selectedPillar?.subPillars.find(sp => sp.id === selectedSubPillarId),
    [selectedPillar, selectedSubPillarId],
  );

  const levelOptions = useMemo(
    () =>
      selectedSubPillar?.levels.map(lv => ({
        label: lv.name,
        value: lv.id,
      })) ?? [],
    [selectedSubPillar],
  );

  return (
    <>
      <FormItem label="Goal" name="subPillarId">
        <Select
          placeholder="Select Goal"
          options={subPillarOptions}
          disabled={disabled || !selectedPillarId}
          onChange={onGoalChange}
          showSearch
          optionFilterProp="label"
          allowClear
          data-cy={goalDataCy}
        />
      </FormItem>

      {selectedSubPillarId && (
        <FormItem label="Level" name="levelId">
          <Select
            placeholder="Select Level"
            options={levelOptions}
            disabled={disabled}
            showSearch
            optionFilterProp="label"
            allowClear
            data-cy={levelDataCy}
          />
        </FormItem>
      )}
    </>
  );
};

export default GoalLevelFields;
